import User, { UserRole } from 'types/User';

export const isMentor = (user: User | undefined | null) => user?.role === UserRole.Mentor || user?.role === UserRole.Supervisor || user?.role === UserRole.Admin;
